/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { PostStreamQualityReportMutationRequest, PostStreamQualityReportMutationResponse } from "../models/PostStreamQualityReport";

export function getPostStreamQualityReportUrl() {
  const res = { method: 'POST', url: `/stream-quality/report` as const }
  return res
}

/**
 * @description Same as GET /stream-quality/report with `from`, `to`, and `stationsFilters` in the JSON body. Empty `stationsFilters` resolves to all stations for the authenticated client.
 * @summary Get stream quality report (POST body)
 * {@link /stream-quality/report}
 */
export async function postStreamQualityReport(data: PostStreamQualityReportMutationRequest, config: Partial<RequestConfig<PostStreamQualityReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostStreamQualityReportMutationResponse, ResponseErrorConfig<Error>, PostStreamQualityReportMutationRequest>({ method : "POST", url : getPostStreamQualityReportUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}